export default "__VITE_ASSET__COM_6OVZ__"